import * as c from '../constants/PricingConstants'
import template from './template'

export const pricingProposedExam = (state, action) =>
  template(state, action, c, 'PROPOSED_EXAM_PRICE')

export const pricingAggregatedFees = (state, action) =>
  template(state, action, c, 'AGGREGATED_FEES')
